import Bandit from "./images/Bandit.webp"
import Bingo from "./images/Bingo.webp"
import Bluey from "./images/Bluey.webp"
import Chilli from "./images/Chilli.webp"
import Muffin from "./images/Muffin.webp"
import Socks from "./images/Socks.webp"
import Lucky from "./images/Lucky.webp"
import Mackenzie from "./images/Mackenzie.webp"

export const cardsArray = [
  {
    type: "Bandit",
    Image: Bandit,
    Flipped: false,
  },
  {
    type: "Bingo",
    Image: Bingo,
    Flipped: false,
  },
  {
    type: "Bluey",
    Image: Bluey,
    Flipped: false,
  },
  {
    type: "Chilli",
    Image: Chilli,
    Flipped: false,
  },
  {
    type: "Muffin",
    Image: Muffin,
    Flipped: false,
  },
  {
    type: "Socks",
    Image: Socks,
    Flipped: false,
  },
  {
    type: "Lucky",
    Image: Lucky,
    Flipped: false,
  },
  {
    type: "Mackenzie",
    Image: Mackenzie,
    Flipped: false,
  },
  {
    type: "Bandit",
    Image: Bandit,
    Flipped: false,
  },
  {
    type: "Bingo",
    Image: Bingo,
    Flipped: false,
  },
  {
    type: "Bluey",
    Image: Bluey,
    Flipped: false,
  },
  {
    type: "Chilli",
    Image: Chilli,
    Flipped: false,
  },
  {
    type: "Muffin",
    Image: Muffin,
    Flipped: false,
  },
  {
    type: "Socks",
    Image: Socks,
    Flipped: false,
  },
  {
    type: "Lucky",
    Image: Lucky,
    Flipped: false,
  },
  {
    type: "Mackenzie",
    Image: Mackenzie,
    Flipped: false,
  },
];
